import { Component, Prop, Vue } from 'vue-property-decorator';
import MoreInfo from '@/components/MoreInfo/MoreInfo';
import LanguagePicker from '@/components/LanguagePicker/LanguagePicker';

@Component({
  components: {
    MoreInfo,
    LanguagePicker,
  },
})
export default class MobileMenu extends Vue {
  @Prop({ required: true, default: false })
  public identified!: boolean;
  @Prop({ required: true, default: null })
  public env!: string|null;
}
